import { Application } from "@hotwired/stimulus"
import StimulusReflex from 'stimulus_reflex'
//import consumer from '../channels/consumer'
import AttendeeComponentController from "../../../components/attendee_component_controller"

window.Stimulus = Application.start()
Stimulus.register("attendee-component", AttendeeComponentController)
//Stimulus.consumer = consumer
//StimulusReflex.initialize(Stimulus, { consumer })